import React, { useReducer, useEffect } from "react";
import SectionHeader from "../../../components/SectionHeader/SectionHeader";
import LoadingOverlay from "react-loading-overlay";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { MdArrowDropDownCircle } from "react-icons/md";
import OrganisationDetailsForm from "../../Organisation/Forms/OrganisationDetailsForm/OrganisationDetailsForm";
import ErrorFooter from "../../../components/ErrorFooter/ErrorFooter";
import MembershipCard from "../../../components/MembershipCard/MembershipCard";

import { request, handleErrors } from "../../../services/helpers";

const SET_ORGANISATION_TYPE = "SET_ORGANISATION_TYPE";
const SET_FORM_LOADING = "SET_FORM_LOADING";
const GET_ORGANISATION_SUCCESS = "GET_ORGANISATION_SUCCESS";
const GET_ORGANISATION_FAILURE = "GET_ORGANISATION_FAILURE";
const GET_ALL_ORGANISATIONS_SUCCESS = "GET_ALL_ORGANISATIONS_SUCCESS";
const GET_ALL_ORGANISATIONS_FAILURE = "GET_ALL_ORGANISATIONS_FAILURE";
const GET_MEMBERSHIPS_SUCCESS = "GET_MEMBERSHIPS_SUCCESS";
const GET_MEMBERSHIPS_FAILURE = "GET_MEMBERSHIPS_FAILURE";

const initialState = {
  organisationType: null,
  organisation: null,
  loading: false,
  error: "",
  memberships: [],
  organisationList: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FORM_LOADING:
      return {
        ...state,
        loading: action.payload === false ? action.payload : true,
        error: "",
      };
    case SET_ORGANISATION_TYPE:
      return {
        ...state,
        organisationType: action.payload,
      };
    case GET_ORGANISATION_SUCCESS: {
      return {
        ...state,
        organisation: action.payload,
        // error: action.payload,
        loading: false,
      };
    }
    case GET_ORGANISATION_FAILURE: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        organisation: null,
      };
    }
    case GET_ALL_ORGANISATIONS_SUCCESS:
      return {
        ...state,
        organisationList: action.payload,
        loading: false,
      };

    case GET_ALL_ORGANISATIONS_FAILURE: {
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    }

    case GET_MEMBERSHIPS_SUCCESS: {
      return {
        ...state,
        loading: false,
        memberships: action.payload,
      };
    }

    case GET_MEMBERSHIPS_FAILURE: {
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    }

    default:
      return state;
  }
};

const SelectMembership = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { loading, error, organisationList, memberships } = state;

  const getAllOrganisations = async () => {};

  const toggleOrganisationType = (type) => {
    dispatch({
      type: SET_ORGANISATION_TYPE,
      payload: type,
    });
  };

  useEffect(() => {
    let active = true;
    (async () => {
      dispatch({ type: SET_FORM_LOADING });
      try {
        // throw new Error("help");
        const res = await request.get("/organizations");
        if (!Array.isArray(res.data))
          throw new Error("Something went wrong. Please reload the page.");
        if (active) {
          dispatch({
            type: GET_ALL_ORGANISATIONS_SUCCESS,
            payload: res.data,
          });
        }
      } catch (e) {
        if (active) {
          dispatch({
            type: GET_ALL_ORGANISATIONS_FAILURE,
            payload: handleErrors(e),
          });
        }
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    if (state.organisation) {
      (async () => {
        try {
          dispatch({ type: SET_FORM_LOADING });
          const res = await request.get(
            `/memberships/?organizationId=${state.organisation._id}`
          );
          dispatch({
            type: GET_MEMBERSHIPS_SUCCESS,
            payload: res.data,
          });
        } catch (e) {
          dispatch({
            type: GET_MEMBERSHIPS_FAILURE,
            payload: handleErrors(e),
          });
        }
      })();
    }
  }, [state.organisation]);

  const handleOrganisationSelect = async (event, value) => {
    // Step 1: Load and display the organisation details
    // Step 2: List all memberships: [], for the selected organisation
    if (value) {
      if (value.gstNumber) {
        toggleOrganisationType("GST");
      } else {
        toggleOrganisationType("PAN");
      }

      dispatch({ type: GET_ORGANISATION_SUCCESS, payload: value });
    }
  };

  return (
    <div className="w-full">
      <LoadingOverlay
        className="h-screen"
        active={loading}
        spinner={loading}
        text="Loading please wait"
      >
        <div className="bg-formBackground">
          <SectionHeader
            path={["dashboard", "Update Existing Membership"]}
            title={"Update Existing Membership"}
          />

          <div className="lg:px-32 px-8 mt-16 pb-4">
            {/* Organisation Form */}
            <div className="lg:flex">
              <div className="lg:mr-6 max-w-xs">
                <h4 className="font-medium text-2xl leading-7">
                  Organisation Details
                </h4>
              </div>

              <div className="w-full lg:mt-0 my-8">
                {/* Autocomplete Organisation Search */}
                <div className="md:w-1/2 w-full mb-6">
                  <label
                    className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
                    htmlFor="center-location"
                  >
                    Select Existing Organisation
                  </label>
                  <Autocomplete
                    options={organisationList}
                    getOptionLabel={(option) =>
                      option?.name || option?.registeredEmail
                    }
                    name="organisationSearch"
                    onChange={handleOrganisationSelect}
                    renderInput={(params) => (
                      <Input
                        params={params}
                        textFieldProps={{
                          placeholder: "Select An Organisation",
                        }}
                      />
                    )}
                  />
                </div>
                {/* Organisation Details  */}
                <div className="mt-8 ">
                  <OrganisationDetailsForm
                    disableAll={true}
                    formState={state}
                  />
                </div>
              </div>
            </div>
            <hr className="border border-b-0 border-black mx-24 border-opacity-25" />
            {/* Show memberships: [], */}
            {memberships.length > 0 && (
              <div className="lg:py-16 py-8 lg:flex">
                <div className="lg:mr-6 max-w-xs">
                  <h4 className="font-medium text-2xl leading-7">
                    Membership Details
                  </h4>
                </div>
                <div className="w-full">
                  {memberships.map((membership) => (
                    <div
                      key={membership._id}
                      className="flex flex-no-wrap flex-col lg:mt-0 my-8"
                    >
                      <MembershipCard membership={membership} />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {error && (
            <div className="error-footer">
              <ErrorFooter message={error} />
            </div>
          )}
        </div>
      </LoadingOverlay>
    </div>
  );
};

export default SelectMembership;

const Input = ({ params, textFieldProps }) => (
  <div className="flex items-center" ref={params.InputProps.ref}>
    <div className="w-full">
      <input
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "4px",
          borderColor: "#cbd5e0",
          border: "1px solid #cbd5e0",
          outline: "none",
        }}
        type="text"
        {...params.inputProps}
        {...textFieldProps}
      />
    </div>
    <div className="-ml-8">
      <MdArrowDropDownCircle />
    </div>
  </div>
);
